import React from "react";
import { useNavigate } from "react-router-dom";

const ThankYou: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="bg-background min-h-screen flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-4xl font-serif text-secondary mb-4">Thank You!</h1>
        <p className="text-lg font-sans text-secondary/80">
          We’ve received your message and will get back to you shortly.
        </p>
        <button
          onClick={() => navigate("/")} // Navigate back to the previous page
          className="mt-12 px-6 py-2 bg-gradientTo text-primary font-semibold rounded-md shadow-md hover:bg-gradientTo/80 transition"
        >
          Go to Home
        </button>
      </div>
    </div>
  );
};

export default ThankYou;
